// extracted by mini-css-extract-plugin
module.exports = {"wrapPatterns":"SwatchGallery_wrapPatterns__EZVp4","selected":"SwatchGallery_selected__167Q_","swatch":"SwatchGallery_swatch__1LHYD"};